import { LuCircleHelp, LuFileQuestion, LuMessageSquare, LuScale, LuTicket } from "react-icons/lu";

/** Right-side quick links — mirrors footer Customer Services column. */
export const HUB_FLOATING_RAIL_ITEMS = [
  {
    key: "help-center",
    label: "Help Center",
    tone: "support",
    accent: true,
    icon: LuCircleHelp,
    href: "/help-center",
  },
  {
    key: "raise-ticket",
    label: "Raise Ticket",
    tone: "auction",
    icon: LuTicket,
    href: "/help-center/raise-ticket",
  },
  {
    key: "feedback",
    label: "Feedback",
    tone: "cart",
    icon: LuMessageSquare,
    href: "/help-center/feedback",
  },
  {
    key: "submit-dispute",
    label: "Submit a Dispute",
    tone: "doc",
    icon: LuScale,
    href: "/submit-dispute",
  },
  {
    key: "faq",
    label: "FAQ",
    tone: "mobile",
    icon: LuFileQuestion,
    href: "/faq",
  },
];
